import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AvvisiContext = createContext();

export const AvvisiProvider = ({ children }) => {
    const [datiAvvisi, setDatiAvvisi] = useState([]);
    
    const user = JSON.parse(sessionStorage.getItem("user"));
    const { token, roles, id } = user || {};
    const role = roles?.[0];
    const headers = {
        Authorization: `Bearer ${token}`,
    };
    const idCliente = user?.idCliente;
    const tipoAvviso = 0;
    
    // Funzione per il polling degli avvisi
    const fetchAvvisi = async () => {
        try {
            let responseAvvisi;
            if (role === "SAT") {
                responseAvvisi = await axios.get(`/messaggio/elenco?id=${id}&tipo=${tipoAvviso}`, { headers: headers });
            } else if (role === "CLIENTE") {
                responseAvvisi = await axios.get(`/messaggio/elenco?id=${idCliente}&tipo=${tipoAvviso}`, { headers: headers });
            }
    
            if (responseAvvisi?.data && Array.isArray(responseAvvisi.data.messaggi)) {
                // Filtra solo i messaggi non letti
                const nonLetti = responseAvvisi.data.messaggi.filter(avviso => avviso.letto === false);
                setDatiAvvisi(nonLetti);
            } else {
                console.error("Formato dei dati di avviso non valido:", responseAvvisi?.data);
            }
        } catch (error) {
            console.error("Errore nel recupero degli avvisi", error);
        }
    };
    

    // Polling per gli avvisi, ogni 3 minuti
    useEffect(() => {
        fetchAvvisi(); 
        const intervalId = setInterval(fetchAvvisi, 180000);

        return () => clearInterval(intervalId); // Pulisce l'intervallo al dismount
    }, []);

    const readReso = async (idAvviso) => {
        try{
            const responseLeggiAvviso = await axios.post(
                `/messaggio/leggi?id=${idAvviso}`,
                {}, 
                { headers: headers } 
            );            
            if (responseLeggiAvviso.data === "OK") {
                if (responseLeggiAvviso.data === "OK") {
                    const removeAvviso = datiAvvisi.filter((avviso) => avviso.id !== idAvviso);
                    setDatiAvvisi(removeAvviso);
                }                            
            }
        } catch(error) {
            console.error("errore nella chiamata per leggere l'avviso", error);
        }
    }

    const markAllAsRead = async () => {
        try {
            // Eseguo una richiesta per ciascun ID avviso
            await Promise.all(datiAvvisi.map((avviso) => readReso(avviso.id)));
            setDatiAvvisi([]);
        } catch (error) {
            console.error("Errore nella chiamata per segnare tutti gli avvisi come letti", error);
        }
    };
    

    return (
        <AvvisiContext.Provider value={{ datiAvvisi, setDatiAvvisi, markAllAsRead, readReso }}>
            {children}
        </AvvisiContext.Provider>
    );
};

export const useAvvisi = () => {
    return useContext(AvvisiContext);
};
